module.exports = __webpack_public_path__ + "static/media/icon_customers.cfd96b88.svg";